import { useApiFetcherSWR } from "hooks/SwrCustom";


export const API_ENDPOINT = {
  URENOVERZICHT: {
    url: "gebruiker/uren/overview",
    method: "get",
  },

};

// SWR hook
export const useUrenoverzichtData = (
    startDate,
    endDate,
    adminId,
    ids
) =>
    useApiFetcherSWR(
        startDate && endDate
            ? {
                  ...API_ENDPOINT.URENOVERZICHT,
                  params: {
                      begin: startDate,
                      eind: endDate,
                      iCommunityId: ids,
                      iAdminId: adminId,
                  },
              }
            : null
    );